import { BKJThemeColorType } from '@bookjane2/bookjane-design-library';
import { AccessStatusEnum } from 'types/graphql';

export const getJaneColorByStatus = (status: AccessStatusEnum | undefined): BKJThemeColorType => {
  switch (status) {
    case 'approved':
      return 'SecondaryAcceptedDefault';
    default:
      return 'Grey6';
  }
};
